module.exports = __webpack_public_path__ + "media/ridley.b6c328fe.wav";